module.exports = {
  NAVIGATION_CHANGE: "NAVIGATION_CHANGE"
};



// WEBPACK FOOTER //
// ./packages/foundation-ui/src/navigation/EventTypes.js